var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSucces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 341.905,
    height: 240.069,
    viewBox: "0 0 341.905 240.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ac,.ai,.aj,.an,.au,.aw,.ay,.az,.bc,.bd,.be,.bj,.bk,.bl,.bm,.bn,.bo,.br,.bs,.bt,.bu,.bv,.bx,.by,.ca,.cb,.cc,.cd,.ce,.cf,.cg,.ch,.cj,.cl,.cm,.cn,.co,.f,.u,.v,.w{isolation:isolate;}.b{fill:#e1e8f8;}.c{fill:#fff;}.ac,.ad,.ae,.af,.ag,.ah,.aj,.ak,.al,.am,.ao,.ap,.aq,.ar,.as,.at,.av,.aw,.ax,.ay,.bb,.bc,.bf,.bp,.bq,.br,.bt,.bu,.bv,.bw,.bx,.by,.bz,.c,.ca,.cb,.cc,.cd,.cg,.ci,.ck,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.t,.u,.v,.w{fill-rule:evenodd;}.d{fill:#9f597f;}.e{fill:#c02633;}.f{fill:#dd8ea9;}.aw,.f{opacity:0.8;}.ac,.ai,.aj,.an,.au,.aw,.ay,.bc,.bd,.be,.bj,.bk,.bl,.bm,.bn,.br,.bs,.bt,.bu,.by,.ca,.cb,.ch,.cj,.f,.u,.v,.w{mix-blend-mode:multiply;}.g{fill:url(#a);}.h{fill:url(#b);}.i{fill:url(#c);}.j{fill:url(#d);}.k{fill:url(#e);}.l{fill:url(#f);}.m{fill:url(#g);}.n{fill:url(#h);}.o{fill:url(#i);}.p{fill:url(#j);}.q{fill:url(#k);}.r{fill:url(#l);}.s{fill:url(#m);}.t{fill:url(#n);}.u,.v,.w{fill:#bea5bb;}.an,.au,.ay,.bj,.bk,.bl,.bm,.bn,.br,.bu,.by,.cn,.co,.v{opacity:0.5;}.w{opacity:0.2;}.x{fill:#a9224e;}.y{fill:url(#o);}.z{fill:#ff717d;}.aa{fill:url(#p);}.ab{fill:url(#q);}.ac{fill:#a583a1;}.ac,.bo,.cd,.ce,.cl{opacity:0.7;}.ad{fill:#e85b48;}.ae{fill:url(#r);}.af{fill:#b82557;}.ag{fill:#b33748;}.ah{fill:url(#s);}.ai,.aj{fill:#935b9d;}.ai,.aj,.bc,.bd,.be,.bs,.bt,.ca,.cb,.ch,.cj{opacity:0.91;}.ak{fill:url(#t);}.al{fill:url(#u);}.am{fill:url(#v);}.an{fill:url(#w);}.ao{fill:#581124;}.ap{fill:#2b1548;}.aq{fill:url(#x);}.ar{fill:url(#y);}.as{fill:url(#z);}.at{fill:url(#aa);}.au{fill:url(#ab);}.av{fill:url(#ac);}.aw{fill:url(#ad);}.ax{fill:url(#ae);}.ay{fill:url(#af);}.az,.bv,.bx,.cc{mix-blend-mode:soft-light;}.ba{fill:url(#ag);}.bb{fill:url(#ah);}.bc{fill:url(#ai);}.bd{fill:url(#aj);}.be{fill:url(#ak);}.bf{fill:url(#al);}.bg{fill:url(#am);}.bh{fill:url(#an);}.bi{fill:url(#ao);}.bj{fill:url(#ap);}.bk{fill:url(#aq);}.bl{fill:url(#ar);}.bm{fill:url(#as);}.bn{fill:url(#at);}.bo{fill:#972a3d;}.bo,.cd,.ce,.cf,.cg,.cl,.cm,.cn,.co{mix-blend-mode:screen;}.bp{fill:url(#au);}.bq{fill:url(#av);}.br{fill:url(#aw);}.bs{fill:url(#ax);}.bt{fill:url(#ay);}.bu{fill:url(#az);}.bv,.cc{fill:#ecd6e0;}.bv,.bx{opacity:0.33;}.bw{fill:#4b1124;}.bx{fill:#ddb6c8;}.by{fill:url(#ba);}.bz{fill:url(#bb);}.ca{fill:url(#bc);}.cb{fill:url(#bd);}.cc{opacity:0.57;}.cd{fill:url(#be);}.ce{fill:url(#bf);}.cf{fill:url(#bg);}.cg{fill:url(#bh);}.ch{fill:url(#bi);}.ci{fill:url(#bj);}.cj{fill:url(#bk);}.ck{fill:url(#bl);}.cl{fill:url(#bm);}.cm{fill:url(#bn);}.cn{fill:url(#bo);}.co{fill:url(#bp);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.69,
    y1: 1,
    x2: 1.69,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8c74b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcd8e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.11,
    y1: 1,
    x2: 1.11,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8268aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9a1ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.488,
    y1: 0.831,
    x2: 0.601,
    y2: -7.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#948abc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f2f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.471,
    y1: 3.084,
    x2: 0.617,
    y2: -10.187,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.449,
    y1: 6.346,
    x2: 0.627,
    y2: -14.145,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.43,
    y1: 8.398,
    x2: 0.638,
    y2: -15.046,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.412,
    y1: 12.144,
    x2: 0.646,
    y2: -18.801,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.357,
    y1: 1.7,
    x2: 0.586,
    y2: -0.083,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.539,
    y1: 0.5,
    x2: 1.539,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#d8cfe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.697,
    y1: 0.501,
    x2: 1.697,
    y2: 0.501,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.836,
    y1: 0.501,
    x2: 1.836,
    y2: 0.501,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 1.101,
    y1: 0.502,
    x2: 2.101,
    y2: 0.502,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 1.244,
    y1: 0.498,
    x2: 2.244,
    y2: 0.498,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.99,
    y1: 0.5,
    x2: 1.99,
    y2: 0.5,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c02633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff717d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.046,
    y1: 0.511,
    x2: 1.002,
    y2: 0.511,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 3.053,
    y1: 0.5,
    x2: 4.053,
    y2: 0.5,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#570e33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#842f40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b3272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#432160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0.499,
    y1: 1,
    x2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4867c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ff9f68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#543c79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#432160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.001,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#be6888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e81f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0.498,
    y1: 1,
    x2: 0.498,
    y2: -0.002,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0.504,
    y1: 1,
    x2: 0.504,
    y2: -0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e1dbeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e7e2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f0ecfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3f0fe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 0.193,
    cy: 0.314,
    r: 0.37,
    gradientTransform: "translate(-0.448) scale(1.896 1)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0.5,
    y1: 1.001,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0.451,
    y1: 1.043,
    x2: 0.536,
    y2: 0.017,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: 0.193,
    cy: 0.314,
    r: 0.496,
    gradientTransform: "translate(0.018) scale(0.965 1)",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0.498,
    y1: 1,
    x2: 0.498,
    y2: -0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b060f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffeadb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 0.498,
    y1: 1.004,
    x2: 0.498,
    y2: 0.005,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 0.499,
    y1: 1.001,
    x2: 0.499,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#d1a1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bd89c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: -0.384,
    y1: 0.982,
    x2: 1.349,
    y2: 0.017,
    xlinkHref: "#ad"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#792244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 0,
    y1: 0.5,
    x2: 0.998,
    y2: 0.5,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 0.323,
    y1: 1.021,
    x2: 0.621,
    y2: -0.042,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 0.346,
    y1: 0.953,
    x2: 0.708,
    y2: 0.033,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#721d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a63624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 0.34,
    y1: 1.027,
    x2: 0.743,
    y2: -0.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8e2a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba4324"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: -0.012,
    y1: 0.999,
    x2: 1.077,
    y2: 0.003,
    xlinkHref: "#am"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 0.175,
    y1: 1.006,
    x2: 1.078,
    y2: 0.003,
    xlinkHref: "#am"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 0.278,
    y1: 1.008,
    x2: 1.367,
    y2: 0.014,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 0.381,
    y1: 1.053,
    x2: 0.602,
    y2: -0.062,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0.378,
    y1: 1.04,
    x2: 0.602,
    y2: -0.061,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 0.421,
    y1: 0.9,
    x2: 0.579,
    y2: 0.1,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0.435,
    y1: 1.064,
    x2: 0.654,
    y2: 0.022,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 0.501,
    y1: 1,
    x2: 0.501,
    y2: 0,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 0.5,
    y1: 1.001,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 0.499,
    y1: 1,
    x2: 0.499,
    y2: 0,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0,
    y1: 0.497,
    x2: 1,
    y2: 0.497,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 0,
    y1: 0.5,
    x2: 0.998,
    y2: 0.5,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 0,
    y1: 0.504,
    x2: 1,
    y2: 0.504,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 0,
    y1: 0.497,
    x2: 1,
    y2: 0.497,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4af4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#47eaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3fcfd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#32a3ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1f676b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#081a1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: -0.216,
    y1: 0.987,
    x2: 1.525,
    y2: 0.009,
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0.121,
    y1: 0.972,
    x2: 1.074,
    y2: 0.026,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#984072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ab4373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d94b76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f54f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    y1: 0.5,
    x2: 1.002,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#1c090d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6b2233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ab3651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d84567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f54e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 0.503,
    y1: 1,
    x2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d2822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#570e33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 0.003,
    y1: 0.499,
    x2: 1.003,
    y2: 0.499,
    xlinkHref: "#af"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 0.502,
    y1: 1,
    x2: 0.502,
    y2: -0.002,
    xlinkHref: "#bj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: -0.437,
    y1: 0.99,
    x2: 0.933,
    y2: 0.014,
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 0.388,
    y1: 0.928,
    x2: 0.613,
    y2: 0.072,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f54e74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d84567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ab3651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6b2233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#1c090d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: -0.029,
    y1: 0.981,
    x2: 1.068,
    y2: 0.002,
    xlinkHref: "#bn"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: -0.641,
    y1: 0.983,
    x2: 1.133,
    y2: 0.019,
    xlinkHref: "#bn"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-55.784 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.784 -3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 112.201,
    cy: 112.201,
    r: 112.201,
    transform: "translate(53.524 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 37.633,
    cy: 37.633,
    r: 37.633,
    transform: "translate(259.778 42.568)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 23.296,
    cy: 23.296,
    r: 23.296,
    transform: "matrix(0.233, -0.973, 0.973, 0.233, 0, 93.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M193.18,102.6h99.748a7.72,7.72,0,0,0-5.044-7.71c-5.675-2.44-11.13,6.1-11.13,6.1s-4.8-24.673-28.929-28.47S218.353,100.2,218.353,100.2s-.939-4.181-3.536-3.859-3.989,4.976-3.989,4.976S200.6,92.454,193.18,102.6Z",
    transform: "translate(-86.677 -26.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M169.529,114.812H148.9S162.58,106.245,169.529,114.812Z",
    transform: "translate(-72.745 -38.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M127.36,46.409l104.477.576s-2.282-7.189-13.186-1.6c0,0-3.379-18.183-20.129-18.573s-21.3,18.443-21.3,18.443-4.188-5.291-9.259-5.01-6.854,5.14-6.854,5.14-7.265-15.325-17.388-16.387S127.36,46.409,127.36,46.409Z",
    transform: "translate(-65.968 -12.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M373.659,39.4l-.569-11.72.281.391.439,11.336Z",
    transform: "translate(-143.283 -12.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M387.415,34.037a23.3,23.3,0,0,1-4.592.912,4.976,4.976,0,0,1-.72,0c-1.693-.151-1.8-1.96-2.673-2.693l-.178-.123c-1.049-.617-5.819.98-5.819.98l-.363-5.689a37.516,37.516,0,0,1,5.483-.6,2.015,2.015,0,0,1,1.014.281c.9.521,1.151,1.631,1.761,2a4.3,4.3,0,0,0,1.693.219c1.638,0,3.8-.219,3.8-.219Z",
    transform: "translate(-143.277 -12.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M385.972,29.444l-.219,5.634a4.976,4.976,0,0,1-.72,0c-1.693-.151-1.8-1.96-2.673-2.693.041-1.672.151-3.886.158-5.154.9.521,1.151,1.631,1.761,2A4.3,4.3,0,0,0,385.972,29.444Z",
    transform: "translate(-146.2 -12.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M370.74,44.56l.11,99.165,22.692,4.057,13.652-80.914Z",
    transform: "translate(-142.544 -17.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M415.267,251.883,403.5,83.66l-19,12.3-45.995,38.846-1.816,11.562Z",
    transform: "translate(-131.831 -30.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M69.41,315.48,72.1,338.234,384.54,343.1l5.1-27.613Z",
    transform: "translate(-47.735 -103.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M369.759,290.83l.315-16.38H122.48l2.344,14.009Z",
    transform: "translate(-64.432 -90.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M359.665,260.029l.185-9.814-203.82-.8,1.261,10.609Z",
    transform: "translate(-74.988 -82.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M350.464,242.05l-.027-8.67-173.856.363.85,8.91Z",
    transform: "translate(-81.454 -77.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M346.766,229.465V223.31l-154.406-.87.212,7.025Z",
    transform: "translate(-86.419 -73.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M203.765,165.911l137.47.562V159.92l-7.539.041v-5.545l-4.407.014-.336-3.859-6.552-.034-.117-4.695h-4.236l-.226-3.42-4.044-.027-.192-3.249-4.619-.027v-3.6h-4.311l.062-1.453v-2.659h0l56.9-60.052L321.99,44.82l-3.845-.26L345.1,66.677,240.034,135.521h-3.413v3.16l-4.112-.027v3.194l-4.263-.027v4.023H223l.11,4.078-5.291-.034.048,4.9-6.518.021.2,5.784-7.964.041Z",
    transform: "translate(-89.949 -17.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M389.639,309.012l-36.578-11.747L108.126,294.9,69.41,309Z",
    transform: "translate(-47.735 -96.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M122.48,271.445l24.344-6.545H349.109l20.965,6.545Z",
    transform: "translate(-64.432 -87.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M156.03,248.353l16.031-1.748L344,246.03l15.852,3.118Z",
    transform: "translate(-74.988 -81.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M346.766,223.052l-9.06-.87-137.443-.562-7.9.562Z",
    transform: "translate(-86.419 -73.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M203.58,213.187l7.957-.768L333.7,211.59l7.539.884Z",
    transform: "translate(-89.949 -70.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M350.436,232.911,341.8,231.89l-155.824.548-9.4.836Z",
    transform: "translate(-81.454 -76.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M63.54,335.78,43.13,343.1H376.272l5.1-27.613L61.141,315.48Z",
    transform: "translate(-39.466 -103.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M122.363,288.466l-7.7,2.8L367.3,290.83l.315-16.38H120.02Z",
    transform: "translate(-61.972 -90.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M358,260.029,150.73,261.373l4.893-1.343-1.261-10.609,203.82.8Z",
    transform: "translate(-73.321 -82.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M176.41,242.653l-3.07.425,177.228-.8-1.124-.226-.027-8.67-173.856.363Z",
    transform: "translate(-80.435 -77.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M82.637,244.517l-2.707-.377,1.028,29.183,1.679-.219Z",
    transform: "translate(-51.045 -80.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M134.953,211.647l-10.815-8.917-.356,5.394-39.9,23.364v28.587l38.552-29.121.1-3.578L122,235.525Z",
    transform: "translate(-52.287 -67.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M79.93,231.111l41.7-23.193.336-5.188h.925l-.356,5.394-39.9,23.364Z",
    transform: "translate(-51.045 -67.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M121.634,210.3l.9.206-39.9,23.364-2.707-.377Z",
    transform: "translate(-51.045 -69.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M139.132,248.481h-.8l.4-3.948.836-.624Z",
    transform: "translate(-69.419 -80.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M343.889,100.958l-.816-.158-.144,8.869.514-.041Z",
    transform: "translate(-133.794 -35.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M359.916,92.092l-3.139-2.872-.192,1.631-12.46,6.463-.445,8.67,12.138-8.231.089-1.083-.288,2.46Z",
    transform: "translate(-134.03 -31.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M343.14,97.15l13.008-6.388.178-1.563.281.014-.192,1.631-12.46,6.463Z",
    transform: "translate(-133.86 -31.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M356.148,91.48l.267.082-12.46,6.463-.816-.158Z",
    transform: "translate(-133.86 -32.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M360.99,103.048l-.24-.014.178-1.193.26-.171Z",
    transform: "translate(-139.401 -35.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M450.14,190.607l2.7-.377-1.028,29.183-1.672-.219Z",
    transform: "translate(-167.526 -63.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M375.61,157.737l10.822-8.917.35,5.394,39.909,23.364v28.587l-38.559-29.128-.1-3.571.535,8.149Z",
    transform: "translate(-144.076 -50.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M434.359,177.2l-41.7-23.2-.336-5.181H391.4l.35,5.394,39.909,23.364Z",
    transform: "translate(-149.044 -50.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M392.815,156.38l-.9.212,39.909,23.364,2.7-.377Z",
    transform: "translate(-149.205 -52.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M394.319,194.568h.8l-.4-3.948-.836-.631Z",
    transform: "translate(-149.825 -63.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M243.434,287.585l-22.336,12.6-1.9,24.3,98.254,1.535-3.523-25.838-21.349-11.8-1.905-16.332-6.86-1.864-1.707-3.338h-4.29l-3.317,2.584-29.135,2.618Z",
    transform: "translate(-94.864 -87.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M306.2,195.21a51.491,51.491,0,0,1,0,8.7s2.282-2.563,5.209-1.48a4.25,4.25,0,0,1-.761-1.707c.034-.589.528-3.907.528-3.907Z",
    transform: "translate(-122.237 -65.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M312.63,221.734l-8.313.226-.487-.459c.884-4.565,1.624-15.428,1.624-15.428s1.487-2.563,3.029-2.563a2.467,2.467,0,0,1,2.173,1.275,22.138,22.138,0,0,1,1.316,4.66s-.685,5.127,0,7.457A21.692,21.692,0,0,1,312.63,221.734Z",
    transform: "translate(-121.492 -67.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M312.853,224.065l-8.313.226s.493-8.142,1.844-11.034,4.928-2.741,5.812-1.48c0,0-.685,5.127,0,7.457A21.7,21.7,0,0,1,312.853,224.065Z",
    transform: "translate(-121.715 -70.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M306.212,198.4s3.255,2.741,4.667.281l.144-1.014L306,196S306.212,197.857,306.212,198.4Z",
    transform: "translate(-122.174 -65.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M313.742,172.165c0,2.673-3.317,14.571-3.317,14.571-2.687,1.665-4.667-.315-5.579-1.371-.192-.226-.336-.418-.432-.521a3.207,3.207,0,0,0-1.371-.809c.274-6.388-.754-20.314-.754-20.314,1.7-2.193,9.492-1.371,9.492-1.371a9.534,9.534,0,0,0,.425,3.18C312.8,167.792,313.742,170.431,313.742,172.165Z",
    transform: "translate(-121.007 -54.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M307.568,169.41s-2.8,9.821-2.6,15.407l-.137.548c-.192-.226-.336-.418-.432-.521a3.207,3.207,0,0,0-1.371-.809c.274-6.388-.754-20.314-.754-20.314,1.7-2.193,9.492-1.371,9.492-1.371a9.534,9.534,0,0,0,.425,3.18Z",
    transform: "translate(-121.001 -54.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M313.894,190s-2.1,4.256-2.974,4.688-2.2-.288-2.2-.288,1.049,1.151,1.9,1.151,2.241-1.6,2.241-1.6Z",
    transform: "translate(-123.03 -63.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M277.39,268.754a15.844,15.844,0,0,1,.562,3.509s3.427.055,4.928,2.111v-9.9Z",
    transform: "translate(-113.173 -86.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M284.333,298.385H273.107a14.972,14.972,0,0,1,0-4.366c.329-2.892.473-10,.439-11.075s3.009-7.279,3.009-7.279c2.865-1.6,4.928,2.111,4.928,2.111s.178,2.111.466,5.483c.308,3.564.4,8.7,1.371,11.261A13.3,13.3,0,0,1,284.333,298.385Z",
    transform: "translate(-111.775 -90.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M273.535,286.088s4.352-2.4,6.532,1.172,2.926,14.283,2.926,14.283H273.1a12.926,12.926,0,0,1-.055-3.77C273.275,295.162,273.535,286.088,273.535,286.088Z",
    transform: "translate(-111.771 -93.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M277.2,269.514s1.665,2.632,5.3-.727V264.47L276.17,266.2S277.088,268.808,277.2,269.514Z",
    transform: "translate(-112.789 -86.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M308.982,146.9c-.267,2.872-4.174,7.854-7.2,8.608s-5.044,0-7.9-.322a9.033,9.033,0,0,0-4.928.809,138.966,138.966,0,0,0-3.468,18.238c-1.083,9.479-1.206,19.272-1.316,20.033a7.381,7.381,0,0,1-1.261,2.2c-1.515,10.829-.617,26.448-.617,26.448s-.247.206-.548.487a7.542,7.542,0,0,0-.966,1.035,4.94,4.94,0,0,0-.356,2.248h0c-1.988,2.31-6.031,1.227-6.031,1.227-3.605-7-4.907-21.863-4.619-23.816s4.4-8.08,4.4-9.163c0-.925-3.2-27.106-3.475-37.962a21.641,21.641,0,0,1,.158-4.044c1.083-5.127,5.538-13.248,5.538-13.248l9.479-4.592,18.073.377.13.206c.727,1.2,4.441,7.422,4.873,10.459a3.229,3.229,0,0,1,.034.774Z",
    transform: "translate(-110.764 -46.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M304.526,135.707v2.323s-7,8.4-13.022,10.184-16.675-1.453-16.675-1.453-3.1,5.757-3.674,10.191h0a21.646,21.646,0,0,1,.158-4.044c1.083-5.127,5.538-13.248,5.538-13.248l9.479-4.592,18.073.377Z",
    transform: "translate(-111.201 -46.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M311.344,151.936c-.267,2.872-4.174,7.854-7.2,8.608s-5.044,0-7.9-.322a9.033,9.033,0,0,0-4.928.809s-.685,2.57-1.508,6.429c-.685,3.269-1.467,7.464-1.96,11.809-1.083,9.479-1.206,19.272-1.316,20.033a7.381,7.381,0,0,1-1.261,2.2c-4.64,6.305-2.015,22.446-1.165,26.935a7.537,7.537,0,0,0-.966,1.035,4.939,4.939,0,0,0-.356,2.248l-.685-17.593.685-13.056-4.763,1.1,5.36-2.275,1.967-11.562-1.878,5.442c1.768-6.71,2.741-19.19,2.741-19.19l-.624-5.174-.617-5.058a21.506,21.506,0,0,1-7.731-.918,16.284,16.284,0,0,0,6.765,0s7.573-4.66,8.492-4.8,4.386.445,10.28,0c5.483-.411,8.156-6.614,8.519-7.539A3.227,3.227,0,0,1,311.344,151.936Z",
    transform: "translate(-113.125 -51.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M340.5,157.979s2.289,15.332,7.34,24.07l2.166-2.166s-6.854-12.563-7.738-21.623l-.11-1.33Z",
    transform: "translate(-133.029 -53.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M338.165,150.81a6.854,6.854,0,0,1-.041,2.968,25.825,25.825,0,0,1-.864,3.427.891.891,0,0,0,.555.5c.363.075,1.193-.685,1.556-1.261s-.219-1.967-.164-2.33a3.426,3.426,0,0,1,.281-.809S338.994,151.351,338.165,150.81Z",
    transform: "translate(-132.01 -51.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M338.033,141.72s5.161-1.3,6.929-4.983a5.545,5.545,0,0,0-4.983.432A4.81,4.81,0,0,0,338.033,141.72Z",
    transform: "translate(-132.241 -46.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M347.231,149.145c0,.473-2.056,1.659-2.056,1.659l-4.112.9-1.59-3.9s-.98-1.193-.9-1.727,1.3-4.907,1.3-5.127a7.724,7.724,0,0,0-.8-1.371,6.077,6.077,0,0,1,.946-1.213A4.2,4.2,0,0,1,342.989,137s.178.158.452.459a10.117,10.117,0,0,1,1.2,1.515l.2.295c.117.192.226.391.336.6a35.987,35.987,0,0,1,1.624,6.429C347.046,147.76,347.231,148.96,347.231,149.145Z",
    transform: "translate(-132.42 -46.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M339,139.8l.946,1.117a7.032,7.032,0,0,1,4.558-2.337l-1.206-1.686A4.194,4.194,0,0,0,339,139.8Z",
    transform: "translate(-132.557 -46.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M275.68,140.627a7.7,7.7,0,0,0,4.8,3.468c3.584,1.014,7.073-2.536,7.073-2.536S280.7,139.907,275.68,140.627Z",
    transform: "translate(-112.635 -47.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M279.437,86.59a7.8,7.8,0,0,0-1.508,3.166c-.137,1.426,4.88,16.449,8.142,18.628s3.468-12.7,3.468-12.7Z",
    transform: "translate(-113.341 -31.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M307.216,135.786s-7.354,9.7-15.695,10.767a19.314,19.314,0,0,1-10.644-1.85,20.5,20.5,0,0,1-4.112-2.522l-.206-.411.946-1.994.576-1.22,6.5-4.5,3.269-2.262,8.2,1.186,10.089,1.467Z",
    transform: "translate(-112.912 -45.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M298.7,142.934c-.164.171-2.906,3.05-9.4,2.741-6.71-.288-9.6-2.776-9.6-2.776l1.22,1.775a20.5,20.5,0,0,1-4.112-2.522l-.206-.411,1.522-3.214,9.718-6.737,18.258,2.652s-5.846,5.2-11.2,5.846c0,0,3.776-1.446,4.633-3.427-.336.11-11.261,4.023-14.763,3.824A11.783,11.783,0,0,0,291.1,144.8C294.885,145.641,298.5,143.071,298.7,142.934Z",
    transform: "translate(-112.924 -45.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M306.537,134.782a109.076,109.076,0,0,1-17,5.627c-8.875,2.056-11.61-.295-11.61-.295l.576-1.22,6.5-4.5,11.473-1.076,4.8-.445Z",
    transform: "translate(-113.343 -45.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M325.355,117.215s-5.846-1.09-6.929,4.976l-.075-.082-.055-.055-.685-.788-.082-.11c-1.885-2.262-6.23-7.909-8.026-14.009a41.062,41.062,0,0,0-1.679-8.91,19.6,19.6,0,0,0-3.728-6.566s-3.632,7.477-3.632,11.966l1.008.973-.733,1.028s3.194,6.278,5.791,10.664c0,0-8.91.487-13.961,4.009l-.809-1.227-.877-1.323-1.617,1.686-1.186,1.24s-7.539,1.138-12.4-.87c0,0,3.564-3.509,6.449-6.956a25.893,25.893,0,0,0,3.242-4.565l-.685-.548,1.138-1.3a100.389,100.389,0,0,0-6.216-18.594l-.864-5.127s9.965-5.051,19.876-6.717l2.454-.788s1.1-.521,1.885-.788a2.193,2.193,0,0,1,.685-.164c.514,0,4.8,3.331,7.477,10.966,1.371,4,3.338,10.349,5.86,16.654h0C319.242,107.668,322.038,113.384,325.355,117.215Z",
    transform: "translate(-112.635 -27.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M347.231,149.346c0,.473-2.056,1.659-2.056,1.659l-4.112.9-1.59-3.9s-.98-1.193-.9-1.727,1.3-4.907,1.3-5.127a7.725,7.725,0,0,0-.8-1.371,6.078,6.078,0,0,1,.946-1.213l3.427-.932a10.118,10.118,0,0,1,1.2,1.515s-2.351,1.371-2.968,2.741.2,4.441.2,4.441a6.7,6.7,0,0,0,4.688.069l.24.075C347.046,147.962,347.231,149.161,347.231,149.346Z",
    transform: "translate(-132.42 -47.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M346.691,154.317c-1.179,1.652-2.131,1.8-2.131,1.8h-.192l-2.536.26h0l-.61-.281h0l-.843.274a5.35,5.35,0,0,1-1.288-3.626v-.206l.4-.8.61.137,2.783-.308.864-.555.487.1a4.181,4.181,0,0,1-.315,1.782l.912,1.158.74-.391a2,2,0,0,1,1.117.644Z",
    transform: "translate(-132.586 -51.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M344.358,156.139h0l-2.536.26-.631-.281h0l-.843.274a5.35,5.35,0,0,1-1.288-3.626v-.206l.4-.8.61.137,2.783-.308.864-.555a15.872,15.872,0,0,0-1.576,1.556A15.247,15.247,0,0,0,344.358,156.139Z",
    transform: "translate(-132.576 -51.292)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "az",
    transform: "translate(175.968 56.193)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M296.992,121.923h-.336l.939-10.1-.829-.644.617-.685c-.212-.994-2.214-10.335-2.741-14.482a19.7,19.7,0,0,1,.994-8.526l.322.123a19.266,19.266,0,0,0-.98,8.355c.569,4.345,2.741,14.441,2.741,14.543v.082l-.487.548.685.541Z",
    transform: "translate(-294.536 -87.49)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M372.77,187.592a16.915,16.915,0,0,0-5.051.288,10.444,10.444,0,0,0-3.8,2.563s-4.174-5.106-8.122-18.471c-.075-.281-.164-.555-.24-.822h0c-4.037-13.282-8.149-16.99-8.149-16.99l-.37.192-.911-1.158.3-1.069,1.323-.274a7.875,7.875,0,0,1,2.056,1.624c2.741,2.927,4.66,8.375,9.314,16.024a135.783,135.783,0,0,0,13.646,18.094Z",
    transform: "translate(-134.801 -51.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M287.547,100.808a2.056,2.056,0,0,0,2.358.164c1.487-.685,3.913-2.207,6.264-6.223s4.2-11.966,4.2-11.966l5.805-8.293-1.885.788-2.454.788-11.932,11.8-3.975,13.1.685,1.227,1.1-.816Z",
    transform: "translate(-115.86 -27.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M356.6,179.989c-.151-.466-2.57,5.819-7.169,10.424,0,0-.87,12.775,4.873,19.43h.589l.925-1.247,2.741,4.153,6.388-13.461S361.176,194.58,356.6,179.989Z",
    transform: "translate(-135.824 -60.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M344.081,149.232a7.209,7.209,0,0,1-1.713-.521,7.888,7.888,0,0,1-.96-3.461,7.539,7.539,0,0,0,.541,3.811l-1.7.994,2.968-.267Z",
    transform: "translate(-132.951 -49.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M340.263,141.678l-.343,1.371s2.556-2.906,5.113-3.427l-.212-.322A6.264,6.264,0,0,0,340.263,141.678Z",
    transform: "translate(-132.847 -47.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M341.521,156.528a18.191,18.191,0,0,1-1.227-3.043,6.4,6.4,0,0,1,.1-1.165,8.283,8.283,0,0,0-.267,1.22A15.588,15.588,0,0,0,341.521,156.528Z",
    transform: "translate(-132.913 -51.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M343.956,156.613s-1.892-2.426-1.96-3.091a5.435,5.435,0,0,1,.11-1.432,7.14,7.14,0,0,0,.137,1.528A15.571,15.571,0,0,0,343.956,156.613Z",
    transform: "translate(-133.497 -51.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M344.246,151.87l-.706,1,.075-.939Z",
    transform: "translate(-133.986 -51.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M302.463,75.278s1.1-.521,1.885-.788l-5.771,8.293s-2.652,10.28-5.188,13.652a14.818,14.818,0,0,1-5.243,4.537v6.456l5.62-.487,9.177-2.275-.733,1.028s-6.442.6-8.91,1.946l-9.684,5.277a25.893,25.893,0,0,0,3.242-4.565l-.685-.548,1.138-1.3a100.389,100.389,0,0,0-6.216-18.594l-.864-5.127s9.965-5.051,19.876-6.717Z",
    transform: "translate(-114.066 -27.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M322.916,113.451a72.654,72.654,0,0,0,4.763,7.717c-1.885-2.262-6.23-7.909-8.026-14.009a41.062,41.062,0,0,0-1.679-8.91,19.6,19.6,0,0,0-3.728-6.566s-3.632,7.477-3.632,11.966c0,0-.158-9.424.685-13.152,0,0-2.81-4.3-3.379-7.094.123.281,2.166,4.8,4.023,6.394l1.11-.685s-1.638-10.671.034-14.639a2.193,2.193,0,0,1,.685-.164s-1.652,7.608,0,13.831l2.406,4.112s6.429,8.265,4.887,8.7-.555,5.483,1.5,9.7a25.319,25.319,0,0,0,6.36,7.628,17.82,17.82,0,0,1-6.011-4.832Z",
    transform: "translate(-122.779 -27.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M299.292,65.882l-2.454.788c-.062.151-.11.295-.164.439q-.637,1.645-1.3,3.18c-6.936,16.031-16.284,23.378-16.284,23.378a6.813,6.813,0,0,0-.774,2.817,1.007,1.007,0,0,0,0,.137h-.35a20.807,20.807,0,0,1,1.021-5.483,20.075,20.075,0,0,0-1.727,5.4,9.41,9.41,0,0,1-4.222,2.817l.219-3.955a7.032,7.032,0,0,1-3.1.809s3.1-2.741,3.68-4.8,1.7-16.49,2.022-17.518,2.584-2.858,2.584-2.858v-.788a89.6,89.6,0,0,1,2.92-19.2,14.927,14.927,0,0,1,7.608-5.8h.589a7.34,7.34,0,0,1,3.77-.583,9.586,9.586,0,0,1,5.969,4.263A79.111,79.111,0,0,1,299.292,65.882Z",
    transform: "translate(-110.895 -17.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M290.858,45.3a4.366,4.366,0,0,1,3.029-.363c1.8.4,3.79,3,4.51,4.153s.857,13.515-2.056,22.028S279.207,91.484,278.522,92.3a72.489,72.489,0,0,0-3.3,6.737l-.918.35a21.71,21.71,0,0,1,.6-4.921c.541-1.494,4.455-3.139,11.322-10.966s11.034-19.7,11.651-27.415-3.5-10.137-4.708-10.657a3.537,3.537,0,0,0-2.3-.13Z",
    transform: "translate(-112.2 -17.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M276.716,98.017s1.611-2.447,1.611-7.539-.644-10.8,0-12.035,3.427-2.693,3.427-2.693-.637-9.348.37-15.03a51.333,51.333,0,0,0-1.659,14.955,16.376,16.376,0,0,0-2.741,3.221c-.411,1.028.1,7.724-1.734,19.876Z",
    transform: "translate(-112.732 -22.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M285.307,50.61s-1.549,2.433-2.056,9.9-.144,11.048-.576,11.59-2.94,1.261-3.722,3.173.918,8.183.528,12.953a12.337,12.337,0,0,1-2.981,7.34l5.106-4.8a68.12,68.12,0,0,1-1.912-8.1c-.925-5.085-.562-6.627-.137-7.717S284.676,72,285,71.52s-.774-5.483-.946-11.8S285.307,50.61,285.307,50.61Z",
    transform: "translate(-112.893 -19.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M311.544,50.89s-.459,10.644-2.454,17.758l2.454-.8S312.455,57.257,311.544,50.89Z",
    transform: "translate(-123.147 -19.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M283.45,103.3s6.168-4.414,9.479-9.6a50.718,50.718,0,0,1-9.1,10.637Z",
    transform: "translate(-115.079 -33.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M295.415,82.07c-6.936,16.031-16.284,23.378-16.284,23.378a6.812,6.812,0,0,0-.774,2.817l-.233.137h-.13a20.807,20.807,0,0,1,1.021-5.483,20.075,20.075,0,0,0-1.727,5.4,9.41,9.41,0,0,1-4.222,2.817l.219-3.955a7.032,7.032,0,0,1-3.1.809s3.1-2.741,3.68-4.8,1.7-16.49,2.022-17.518A23.228,23.228,0,0,0,276.3,90.1l.528-3.591s.555,4.4,1.165,7.258a46.26,46.26,0,0,1,1.316-6.5,16.607,16.607,0,0,1,.994-2.371,8.8,8.8,0,0,0,0,2.6s8.944-1.007,11.466-2.837c0,0-2.783,5.051-4.188,7.3a51.281,51.281,0,0,0,6.593-7.676A19.2,19.2,0,0,0,295.415,82.07Z",
    transform: "translate(-110.904 -29.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M305.69,48.657a.829.829,0,0,0-.13-.137.865.865,0,0,1,.13.137Z",
    transform: "translate(-122.036 -19.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "M303.105,66.191l-2.454.788c-.062.151-.11.295-.164.439a23.681,23.681,0,0,0,.857-3.283s-.809-3.166-1.6-3.276a54.321,54.321,0,0,1-2.378,8.505,23.3,23.3,0,0,1-6.854,1.515c-3.125.041-8.08.048-8.08.048l-.164-.425a89.6,89.6,0,0,1,2.9-19.142,14.28,14.28,0,0,0,.26,4.112l.9-3.66.034,2.207,1.117.768s.377-3.934,1.275-5.524,3.653-3.427,4-3.653a13.858,13.858,0,0,0-3.207,3.653,12.961,12.961,0,0,0-.8,4.112,5.919,5.919,0,0,0,3.667-.219l.918-7.347a40.532,40.532,0,0,0,0,7.2,14.693,14.693,0,0,0,5.887-1.446s.281-2.508-.843-3.79c.4.445,1.426,1.9,2.056,5.483l.918-1.919,1.761-2.056A79.115,79.115,0,0,1,303.105,66.191Z",
    transform: "translate(-114.708 -18.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M288.453,50.61l-.843,1.241h2.056a27.035,27.035,0,0,0-.6,2.673l-1.48-.35L286.5,52.933a24.315,24.315,0,0,1,1.953-2.323Z",
    transform: "translate(-116.039 -19.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M292.066,53h3.639l-.308,2.447a6.388,6.388,0,0,1-3.667.219Z",
    transform: "translate(-117.685 -20.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M298.16,52.644s3.845.226,6.024-.774V53.5a10.52,10.52,0,0,1-5.887,1.446Z",
    transform: "translate(-119.708 -20.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M308.69,49.486l1.439-.966,1.288,1.624L309.656,52.2A8.835,8.835,0,0,0,308.69,49.486Z",
    transform: "translate(-123.021 -19.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M280.41,85.056l.411.075s.247-.726,2.783-1.96L282.768,83S280.876,83.932,280.41,85.056Z",
    transform: "translate(-114.123 -29.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M283.77,85.223a60.758,60.758,0,0,0,8.259-.151l.809-1.672h-7.265C285.586,83.4,283.928,84.353,283.77,85.223Z",
    transform: "translate(-115.18 -30.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M302.847,79.967l2.783-1.727-1.371,3.776-3.509,2.6A18.371,18.371,0,0,0,302.847,79.967Z",
    transform: "translate(-120.523 -28.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "M281.8,54s-2.214,8.444-4.174,16.62-4.16,10.054-4.8,12.035,1.371,9.725.864,11.692a11.65,11.65,0,0,1-2.131,3.824,5.839,5.839,0,0,0,2.412-3.194c.836-2.365-1.33-8.985-.212-12.679s3.194-7.58,4.3-10.2,2.275-10.013,2.275-10.013Z",
    transform: "translate(-111.338 -20.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M301.818,77.43s-2.974,10.356-5.572,16.449-9.746,7.991-9.746,7.991l.87-.87a18.45,18.45,0,0,0,8.08-7.361,39.416,39.416,0,0,0,4.3-11.9Z",
    transform: "translate(-116.039 -28.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "M298,75.522s5.846-6.573,7.4-14.262a62.451,62.451,0,0,1-3.283,13.118A37.405,37.405,0,0,1,298,75.522Z",
    transform: "translate(-119.657 -23.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "M311.347,151.952c-.267,2.872-4.174,7.854-7.2,8.608s-5.044,0-7.9-.322a9.033,9.033,0,0,0-4.928.809s-.685,2.57-1.508,6.429l-4.215,1.988-.617-5.058a21.507,21.507,0,0,1-7.731-.918,16.284,16.284,0,0,0,6.765,0s7.573-4.66,8.492-4.8,4.386.445,10.28,0c5.483-.411,8.156-6.614,8.519-7.539a3.228,3.228,0,0,1,.041.8Z",
    transform: "translate(-113.129 -51.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "M271.94,180s2.906,21.054,4.873,26.462C276.813,206.441,272.893,199.416,271.94,180Z",
    transform: "translate(-111.458 -60.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "M271.46,253s1.72,7.046,2.8,8.91a6.758,6.758,0,0,0,3.653,2.563,9.718,9.718,0,0,1-2.858-.178c-.864-.329-1.5-2.625-1.5-2.625A76.135,76.135,0,0,1,271.46,253Z",
    transform: "translate(-111.307 -83.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "M269.81,232.487s1.871-5.14,3.9-6.059a20.1,20.1,0,0,1,5.483-1.158,122.383,122.383,0,0,1,0,13.927c-.363,10.39-3.05,13.79-3.05,13.79S270.1,249.669,269.81,232.487Z",
    transform: "translate(-110.788 -74.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "M357.42,209.854s4.873-9.6,7.416-12.4c0,0-6.436-13.474-6.388-14.338a24.787,24.787,0,0,1,.685-3.118l.322,1.021a10.013,10.013,0,0,0-.35,2.145c0,.9,6.518,14.187,6.518,14.187l-7.052,11.59Z",
    transform: "translate(-138.353 -60.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "M372,204.011s-.541-7.539,0-8.875,8.834,6.024,8.834,6.024S375.214,198.343,372,204.011Z",
    transform: "translate(-142.865 -65.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "M378.009,203.69l-10.966,15.441-4.263.87s3.9-9.019,6.388-13.461C369.174,206.541,370.874,201.161,378.009,203.69Z",
    transform: "translate(-140.039 -67.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "M369.609,189.493a25.043,25.043,0,0,1-5.449-10.041l.041-2.412s9.136,13.879,12.337,16.812C376.51,193.852,371.233,189.164,369.609,189.493Z",
    transform: "translate(-140.474 -59.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "M357.024,215.273l-.864-1.72,4.551-7.443.932,1.4Z",
    transform: "translate(-137.957 -68.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "M314.765,96.874l-1.22-2.6-1.11.685a22.616,22.616,0,0,1-2.865-4.112,39.167,39.167,0,0,0,2.221,4.8v9.019A62.485,62.485,0,0,1,314.765,96.874Z",
    transform: "translate(-123.298 -32.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M288.8,122.7l7.628-.864v.466s-5.414,1.611-6.929.946Z",
    transform: "translate(-116.763 -42.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "M302.544,129.668a27.566,27.566,0,0,1-9.718,4.112l-.877-1.323-1.617,1.686c-.3,0-.6.048-.912.062-7.32.308-10.37-.829-10.37-.829s5.3-6.168,10.089-9.061,12.439-3.386,12.439-3.386S303.387,126.913,302.544,129.668Z",
    transform: "translate(-113.695 -41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M275.68,139.076a35.6,35.6,0,0,0,11.891.439l3.386-3.194,1.857,2.577a23.988,23.988,0,0,1,13.707-3.338l-.322.514-.384-.459a32.9,32.9,0,0,0-13.255,3.955l-1.686-2.55-2.81,2.926S280.066,141.331,275.68,139.076Z",
    transform: "translate(-112.635 -46.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M316.233,74.25l-.363,2.179a32.445,32.445,0,0,1,6.285,7.539,44.986,44.986,0,0,1,3.742,7.745S322.408,77.937,316.233,74.25Z",
    transform: "translate(-125.28 -27.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "M335.1,112.62s1.919,8.224,3.708,11.459a15.428,15.428,0,0,0,5.243,5.2A83.746,83.746,0,0,1,335.1,112.62Z",
    transform: "translate(-131.33 -39.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "M287.776,224.64s-2.385,2.515-2.652,10.753a73.811,73.811,0,0,0,1.487,16.181l.548-.487a160.317,160.317,0,0,1,.617-26.448Z",
    transform: "translate(-115.602 -74.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "M287.9,299.539l-1.336-3.612s-2.275-10.1-2.275-11.9a30.84,30.84,0,0,1,.761-5.092s.178,2.111.466,5.483c.308,3.564.4,8.7,1.371,11.261a13.3,13.3,0,0,1,1.014,3.865Z",
    transform: "translate(-115.344 -91.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M355.574,171.143h0c-4.051-13.275-8.163-16.983-8.163-16.983l-.37.192-.911-1.158.3-1.069,1.323-.274a7.875,7.875,0,0,1,2.056,1.624l-1.234,1.1S354.135,162.864,355.574,171.143Z",
    transform: "translate(-134.801 -51.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "M299.22,45.109s1.268-.891,4.215.137a7.889,7.889,0,0,1,4.427,4.332,74.338,74.338,0,0,1,.685,15.078s.918-9.6-.13-15.763a9.833,9.833,0,0,0-4.873-3.975C300.522,44.019,299.22,45.109,299.22,45.109Z",
    transform: "translate(-120.041 -17.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ch",
    d: "M281.8,292.54l-8.389,1.569.24-5.97h6.566A14.886,14.886,0,0,1,281.8,292.54Z",
    transform: "translate(-111.92 -94.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "M273.751,287.061a131.371,131.371,0,0,1,2.221,14.3h1.871s.617-9.67,2.454-14.276c0,0-1.008-2.4-3.283-2.365a5.284,5.284,0,0,0-3.283.939Z",
    transform: "translate(-112.021 -93.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "M312.184,215.065l-6.854,4.112a26.816,26.816,0,0,1,1.049-4.941c.6-1.384,6.045-2.056,6.045-2.056Z",
    transform: "translate(-121.964 -70.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "M306.89,213.742s1.775,3.509,2.131,10.363l1.837-.048s.768-10.493,2.056-12.337c0,0-.685-1.282-2.926-1.035C307.562,210.932,306.89,213.742,306.89,213.742Z",
    transform: "translate(-122.454 -70.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "M316.839,168.29a30.067,30.067,0,0,1,.281,6.566c-.254,3.509-.85,8.313-.85,8.313s1.8-6.751,1.864-9.088A18.8,18.8,0,0,0,316.839,168.29Z",
    transform: "translate(-125.406 -56.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "M352.14,155a94.746,94.746,0,0,1,6.621,13.111c2.879,7.046,15.9,20.472,15.9,20.472s-9.129-10.28-14.29-19.149C358.809,166.747,354.409,157.879,352.14,155Z",
    transform: "translate(-136.692 -52.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M274.185,222.43a53.824,53.824,0,0,0-2.94,10.719c-.774,5.483,1.371,17.573,1.371,17.573s-3.427-12.487-2.81-19.129C270.361,228.989,274.028,223.636,274.185,222.43Z",
    transform: "translate(-110.763 -73.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "M302.3,164.38s3.824,10.705.754,20.3C303.054,184.68,302.958,167.279,302.3,164.38Z",
    transform: "translate(-121.01 -55.489)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/succes.d82d7b7bbdd784b3126f1a361fed300a.svg";
export { ForwardRef as ReactComponent };